import React from 'react'
import { Image, Divider, Container, Button, Grid, Header, List, Segment } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

import { CustomMessage, Navbar } from 'components'
import 'styling/semantic.less'

import YouTube from 'react-youtube';
import ImageGallery from 'react-image-gallery';
import ResponsiveEmbed from 'react-responsive-embed';


const images = [
  {
    original: './assets/openclaw/screenshot_1.png',
    thumbnail: './assets/openclaw/screenshot_1_tn.jpg',
  },
  {
    original: './assets/openclaw/screenshot_2.png',
    thumbnail: './assets/openclaw/screenshot_2_tn.jpg',
  },
  {
    original: './assets/openclaw/screenshot_3.png',
    thumbnail: './assets/openclaw/screenshot_3_tn.jpg',
  },
  {
    original: './assets/openclaw/screenshot_4.png',
    thumbnail: './assets/openclaw/screenshot_4_tn.jpg',
  },
  {
    original: './assets/openclaw/screenshot_5.png',
    thumbnail: './assets/openclaw/screenshot_5_tn.jpg',
  },
  {
    original: './assets/openclaw/screenshot_6.png',
    thumbnail: './assets/openclaw/screenshot_6_tn.jpg',
  },
  {
    original: './assets/openclaw/screenshot_8.png',
    thumbnail: './assets/openclaw/screenshot_8_tn.jpg',
  },
  {
    original: './assets/openclaw/screenshot_9.png',
    thumbnail: './assets/openclaw/screenshot_9_tn.jpg',
  },
]

class OpenClaw extends React.Component {
    
  render() {
    return (
        <Segment padded='very'>
          <Image src="./assets/openclaw/captain_claw.png" size='large' centered />
          <Header as='h1'>OpenClaw</Header>
          <p style={{fontSize: 16}}>
            <ul style={{lineHeight: 2}}>
              <li>C++ open source and multiplatform reimplementation of original Captain Claw (1997) platformer game</li>
              <li>Whole game engine was written from scratch <i>(~55k C++ LOC, ~25k XML LOC)</i></li>
              <li>OpenClaw uses original game archive with original proprietary file formats</li>
              <li>OpenClaw has almost identical gameplay as original game and has much better performance</li>
            </ul>
          </p>

          <Divider section/>

          <Header as='h2'>Technology</Header>
          <p style={{fontSize: 16}}>
            <ul style={{lineHeight: 2}}>
              <li><b>Languages</b>: <b>C++</b>, <i>C, C#, XML</i></li>
              <li><b>Libraries</b>: SDL, Box2D, TinyXML</li>
              <li><b>Windows</b>: MS Visual Studio 2013</li>
              <li><b>Linux</b>: CMake</li>
              <li><b>Versioning</b>: Git</li>
              <li><b>Continuous integration</b>: Travis CI, Appveyor</li>
            </ul>
          </p>

          <Header as='h2'>Skills</Header>
          <p style={{fontSize: 16}}>
            <ul style={{lineHeight: 2}}>
              <li>Application of OOP principles and game engine architecture design</li>
              <li>Reverse engineering of existing software and unknown file formats</li>
              <li>Creating a dynamic-link library to separate responsibilities</li>
              <li>Application of Test-driven development principles</li>
              <li>Profiling and optimizing critical sections of code</li>
              <li>Debugging and writing safe code</li>
              <li>Usage and modifications of existing third party libraries</li>
              <li>Distribution for multiple platforms</li>
              <li>Resolving issues and requests created by community</li>
            </ul>
          </p>

          <Divider section/>

          <Header as='h2'>In-game screenshots</Header>
          <div>
            <ImageGallery items={images} 
            infinite={true} 
            showPlayButton={false} 
            showFullscreenButton={true} 
            lazyLoad={true}
            />
          </div>

          <Divider section/>

          <Header as='h2'>Level 1 - Video playthrough</Header>
          {/*<YouTube videoId='ikXQNV_aw68' opts={{height: '600', width: '100%'}} />*/}
          <ResponsiveEmbed src='https://www.youtube.com/embed/ikXQNV_aw68' ratio='16:9' />

        </Segment>
    )
  }
}

export default OpenClaw



// WEBPACK FOOTER //
// ./src/OpenClaw.js